<template>
  <div
    v-on:lock="noScroll()"
    v-on:unlock="scroll()"
    id="preference-modal"
    class="md-layout"
  >
    <md-progress-bar md-mode="indeterminate" v-show="!loaded"></md-progress-bar>

    <div
      class="md-layout md-layout-item md-size-100 mg ipadmini content-light-w"
    >
      <!-- Alert per pari opportunità -->
      <div
        class="title-alert"
        v-if="
          electionType && electionType.indexOf('EQUAL_OPPORTUNITIES') !== -1
        "
      >
        <b v-if="electionType == 'AIDED_EQUAL_OPPORTUNITIES'">
          {{ $t("preference.not-three.sex-preference") }}</b
        >
        <span v-if="electionType == 'AIDED_THREE_EQUAL_OPPORTUNITIES'">
          {{ $t("preference.three.sex-preference") }}</span
        >
      </div>
      <div class="fullsize">
        <div v-if="candidates.length > 20" class="input-focus">
          <div
            class="search-w no-selection"
            v-bind:class="showAll ? 'disabled' : ''"
          >
            <input
              type="text"
              id="kinput"
              :disabled="showAll"
              :aria-disabled="showAll"
              :value="typeahead"
              placeholder="Cerca"
              @input="evt => (typeahead = evt.target.value)"
              @keydown.enter="hideKeyboard()"
              @keyup="scrollToElement({ behavior: 'auto', block: 'start' })"
              autocomplete="off"
            />
            <md-icon style="float:right;color:#fff">search</md-icon>
          </div>

          <div class="check-w">
            <md-switch
              v-model="showAll"
              @change="mostraTutti"
              :aria-label="$t('preference-mobile.input-box.show-all')"
              role="switch"
              :aria-checked="showAll"
              >{{ $t("preference-mobile.input-box.show-all") }}</md-switch
            >
          </div>
          <div
            v-if="pages.length > 1"
            class="num-page-top"
            aria-live="assertive"
            :aria-label="
              $t('preference-mobile.pagination.candidates-pagination-label') +
                ' ' +
                page +
                ' ' +
                $t('preference-mobile.pagination.of') +
                ' ' +
                pages.length
            "
            :key="refreshPageTopKey"
          >
            {{ $t("preference-mobile.pagination.page") }} {{ page }}
            {{ $t("preference-mobile.pagination.of") }} {{ pages.length }}
          </div>
          <span v-if="pages.length > 1" class="screenreader"
            >{{ $t("preference-mobile.screen-reader.pagination") }}.</span
          >
        </div>

        <div
          class="md-layout-item md-size-100 fullsize"
          v-if="preference && candidates"
        >
          <div
            :id="candidate.CandidateIdentifier.Id"
            v-for="candidate in displayedPosts"
            :key="candidate.CandidateIdentifier.Id"
          >
            <div>
              <candidate
                :candidate="candidate"
                @candidateSelected="candidateSelected"
                :disabled="tooMany"
                :sexVoted="sexVoted"
                :previousVoted="voted"
              >
              </candidate>
            </div>
          </div>
        </div>
      </div>
      <!-- paginazione -->
      <nav
        :aria-label="$t('preference-mobile.pagination.navigation')"
        v-if="pages.length > 1"
        class="paginator"
      >
        <div class="num-page" :key="refreshPageKey">
          {{ $t("preference-mobile.pagination.page") }} {{ page }}
          {{ $t("preference-mobile.pagination.of") }} {{ pages.length }}
        </div>
        <ul class="pagination">
          <li class="page-item">
            <md-button
              type="button"
              class="page-link"
              :disabled="page == 1"
              :aria-label="$t('preference-mobile.pagination.previous-page')"
              :aria-disabled="page == 1"
              @click="
                page--;
                pageChanged = true;
                readPageFocus(false);
              "
            >
              &lt; {{ $t("preference-mobile.pagination.previous-button") }}
            </md-button>
          </li>
          <li class="page-item">
            <md-button
              type="button"
              @click="
                page++;
                pageChanged = true;
                readPageFocus(true);
              "
              :disabled="page == pages.length"
              :aria-label="$t('preference-mobile.pagination.next-page')"
              :aria-disabled="page == pages.length"
              class="page-link"
            >
              {{ $t("preference-mobile.pagination.next-button") }} &gt;
            </md-button>
          </li>
        </ul>
      </nav>
    </div>
    <div class="toolbar md-layout md-layout-item md-size-100 md-layout">
      <div
        class="md-layout-item md-size-100 md-caption mg preferenze-label "
        tabindex="0"
      >
        <!--aria-live="assertive"-->
        <span class="screenreader"
          >{{ $t("election.preferences-summary") }}:
        </span>
        {{ $t("election.preferences.candidates.max-number") }}:
        {{ preference.MaxVotes }}<br />
        <span class="screenreader"> e </span>
        {{ $t("election.preferences.candidates.selected-number") }}:
        {{ voted.length }}
      </div>

      <div class="md-layout-item">
        <md-button
          tabindex="-1"
          @click="vote"
          class="md-raised md-accent"
          :disabled="ready"
          :aria-disabled="ready"
          id="test"
        >
          <md-tooltip
            v-bind:style="isMobile ? 'display: none;' : ''"
            class="tooltip"
            >{{ $t("preference-mobile.no-preferences-button") }}
          </md-tooltip>
          {{ $t("preference-mobile.no-preferences-button") }}
        </md-button>
      </div>
      <div class="md-layout-item">
        <md-button
          tabindex="-1"
          @click="vote"
          class="md-raised md-primary md-mini"
          :disabled="!ready"
          :aria-disabled="!ready"
        >
          <md-tooltip
            v-bind:style="isMobile ? 'display: none;' : ''"
            class="tooltip"
            >{{ $t("preference-mobile.confirm-preferences-button") }}
          </md-tooltip>
          {{ $t("preference-mobile.confirm-preferences-button") }}
        </md-button>
      </div>
    </div>

    <no-all-preference-dialog
      @opened="noScroll()"
      @closed="scroll()"
      :confirmVoteDialog="confirmVoteDialog"
      @openFinalConfirm="
        confirmVote();
        confirmVoteDialog = false;
      "
      @cancel="confirmVoteDialog = false"
    ></no-all-preference-dialog>
  </div>
</template>

<script>
import PreferenceMixin from "./PreferenceLogicMixin";
import MobileMixin from "./MobileLogicMixin";
import Candidate from "./Candidate";
import Utils from "../utils/Utils.js";
import NoAllPreferenceDialog from "./NoAllPreferenceDialog";
import EqualOppDialog from "./EqualOppDialog";

import { isMobile } from "mobile-device-detect";

export default {
  mixins: [PreferenceMixin, MobileMixin],
  mounted() {
    this.isMobile = isMobile;

    if (this.previousVoted && process.env.VUE_APP_persistPreference == "true") {
      this.previousVoted.forEach(c => {
        this.voted.push(c);
      });
    }

    this.confirmEqual = this.voted.length == 0 ? true : false;

    this.checkIfReady();

    this.utils = new Utils();
    this.getPreference();
    document.getElementById("test").focus();
  },
  data: function() {
    return {
      candidates: [],
      voted: [],
      ready: false,
      alLeastOne: false,
      tooMany: false,
      contestNames: {},
      confirmVoteDialog: false,
      loaded: false,
      typeahead: "",
      equalOpps: false,
      utils: null,
      showAll: false,
      confirmEqual: true,
      isMobile: false,
      numCandidates: 0,
      lastFocus: "",
      page: 1,
      perPage: 100,
      pages: [],
      pageChanged: false,
      refreshPageKey: 0,
      refreshPageTopKey: 0
    };
  },
  props: ["preference", "electionType", "previousVoted"],
  methods: {
    async getPreference() {
      // console.log("Preference retrieved. Type is: %s.", this.electionType);
      this.$emit("preferenceRetrieved");
      // console.log( "Getting contests: %s", this.preference.ChoicesContest.length);
      let contestList = this.preference.ChoicesContest.map(id => {
        return {
          Id: id.ChoicesContestIdentifier.Id,
          Category: id.ChoicesContestIdentifier.Category
        };
      });
      let candidates = [];
      let contest = null;
      for (const c of contestList) {
        contest = await this.getContest(c.Id);
        candidates = candidates.concat(contest);
      }

      this.candidates = candidates;
      this.loaded = true;
      this.numCandidates = candidates.length;
    },
    hideKeyboard() {
      document.activeElement.blur();
    },
    scrollToElement(options) {
      const el = this.$el.getElementsByClassName("input-focus")[0];
      el.scrollIntoView(options);
    },
    noScroll() {
      document
        .getElementById("preference-modal")
        .setAttribute("aria-hidden", "false");
      document
        .getElementById("preference-modal")
        .setAttribute("aria-hidden", "true");
      // document.documentElement.style.overflow = "hidden";
      this.lastFocus = document.activeElement;
      this.hidediv = true;
      this.$forceUpdate();
    },
    scroll() {
      document
        .getElementById("preference-modal")
        .setAttribute("aria-hidden", "false");
      document
        .getElementById("preference-modal")
        .setAttribute("aria-hidden", "false");
      this.lastFocus.focus();
      // document.documentElement.style.overflow = "auto";
      this.hidediv = false;
      this.$forceUpdate();
    },
    readPageFocus(val) {
      if (val) {
        this.refreshPageKey++;
        this.refreshPageTopKey++;
      } else {
        this.refreshPageKey--;
        this.refreshPageTopKey--;
      }
      this.$forceUpdate();
    }
  },
  computed: {
    unorderedContests() {
      return new Utils().unorderedContests(this.contestList);
    },
    orderedContests() {
      return new Utils().orderedContests(this.contestList);
    }
  },
  components: {
    // Contest: () => import("./Contest")
    Candidate,
    NoAllPreferenceDialog
    // EqualOppDialog
  }
};
</script>
<style scoped>
.title-alert {
  font-weight: bold;
  font-size: 16px;
  padding: 22px;
  background: #fff3cd;
  border-radius: var(--br);
  background-color: var(--pcolor);
  margin: 10px 30px 25px 30px;
  color: #fff;
  flex: 1 1 100%;
}

.dialog {
  height: 100%;
  width: 100%;
  max-height: 100%;
  max-width: 100%;
  /* background-color: red; */
}

.toolbar {
  border-top: 2px solid #ddd;
  position: sticky;
  bottom: 0px;
  background: #fff;
  z-index: 9999;
}
.mg {
  /* margin: 10px; */
  padding: 5px;
}

.md-card {
  z-index: 0;
}
.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
  color: #fff !important;
  background-color: var(--pcolor) !important;
}

.search-w {
  float: left !important;
  margin-bottom: 30px !important;
  margin-left: 20px;
  margin-right: 80px;
  width: 65%;
  margin-top: 10px;
  background: var(--pcolor);
  border-radius: var(--br);
  padding: 10px 20px;
}

.search-w ::placeholder {
  color: #fff;
  opacity: 1; /* Firefox */
}

.search-w.disabled {
  background: #ccc;
}
.search-w.disabled ::placeholder {
  color: #ccc;
}

.search-w input:disabled {
  background: #ccc;
}
.check-w {
  float: left !important;
  margin-bottom: 0px !important;
  margin-right: 10px;
  width: 20%;
  margin-top: 5px;
}

.fullsize {
  width: 100% !important;
  max-width: 100% !important;
  float: left !important;
}

.md-layout-item {
  /* flex: none;
  width: 100%; */
  text-align: center;
}

.preferenze-label {
  font-weight: bold;
  font-size: 14px;
  color: var(--pcolor) !important;
  padding-top: 8px;
}

.search-w input {
  width: 90%;
  border: none;
  height: 32px;
  line-height: 32px;
  font-size: 16px;
  background: var(--pcolor);
  color: #fff;
  border-bottom: 1px solid #fff;
  border-radius: 0;
}

.search-w input:focus {
  outline: none;
}

.search-w label {
  float: left;
  font-size: 12px !important;
  color: #555;
}

.search-w:focus-within label,
.search-w:focus-within {
  color: #448aff;
}

.help-text {
  text-align: left;
  margin-left: 20px;
  font-size: 16px;
  margin-top: 0;
  margin-bottom: 0;
}
.paginator {
  margin: 0 auto;
}
ul {
  list-style: none;
  padding: 0;
}

li {
  display: inline;
}
button.page-link {
  display: inline-block;
}
button.page-link {
  font-size: 18px;
  color: var(--pcolor);
  background-color: white;
  font-weight: 500;
  border: 1px solid;
  width: 120px;
  text-transform: none;
}
button.page-link.selected {
  background: var(--pcolor);
  color: #fff;
}
.offset {
  width: 500px !important;
  margin: 20px auto;
}
.num-page {
  margin-top: 20px;
  font-size: 16px;
}
.num-page-top {
  padding-bottom: 5px;
  font-size: 16px;
}
.content-light-w {
  background-color: #f5f5f5;
  padding-top: 15px;
}

.md-button {
  border-radius: var(--brb);
}

.md-button.md-theme-default.md-raised:not([disabled]).md-accent {
  background-color: #fff !important;
  border: 1px solid var(--pcolor);
  color: var(--pcolor);
  box-shadow: none;
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .ipadmini {
    padding-bottom: 15%;
  }
}

@media screen and (max-width: 750px) {
  .search-w {
    float: left !important;
    margin-bottom: 10px !important;
    margin-left: 0;
    margin-right: 0;
    width: 100%;
    margin-top: 10px;
  }

  .check-w {
    width: 100%;
    margin: 0 auto;
  }

  .search-w label {
    font-size: 14px;
  }

  .no-selection {
    -webkit-user-select: none; /* Chrome all / Safari all */
    -moz-user-select: none; /* Firefox all */
    -ms-user-select: none; /* IE 10+ */
    user-select: none; /* Likely future */
  }

  .help-text {
    margin-left: 0px;
  }

  .title-alert {
    font-weight: bold;
    font-size: 24px;
    padding: 12px;
    background: #fff3cd;
    border-radius: var(--br);
    background-color: var(--pcolor);
    margin: 0px 5px 16px;
    color: #fff;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 100%;
    flex: 1 1 100%;
    text-align: center;
    font-size: 16px;
  }
}
</style>
